"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.list.title': 'Onboarding Steps',
    'step.list.empty': 'No steps found',
};
